import { removeLoginMessageError, saveLoginMessageError } from "../../shared/services/local-storage/login-message-error.service";

export const getCommonErrorTranslate = (code: string): string => {
    return `commonErrors.${code}`
}

export const handleUnauthorizedMessage = (messageCode: string): void => {
    if (messageCode) {
        saveLoginMessageError(getCommonErrorTranslate(messageCode));
    } else {
        removeLoginMessageError();
    }
}